import moment from 'moment';
import { sortBy, reverse } from 'lodash';

export function sortFlightLegsByDeparture(legA, legB)
{
    const departureA = moment(`${legA.departure_date} ${legA.departure_time}`, 'MM/DD/YYYY H:mm A');
    const departureB = moment(`${legB.departure_date} ${legB.departure_time}`, 'MM/DD/YYYY H:mm A');

    if (!departureA.isValid() && !departureB.isValid())
    {
        return 0;
    }

    if (!departureA.isValid())
    {
        return 1;
    }

    if (!departureB.isValid())
    {
        return -1;
    }

    return departureA.isBefore(departureB) ? -1 : 1;
}

export function sortHotelRoomsByCheckin(roomA, roomB)
{
    const checkinA = moment(`${roomA.checkin} ${roomA.checkin}`, 'MM/DD/YYYY');
    const checkinB = moment(`${roomB.checkin} ${roomB.checkin}`, 'MM/DD/YYYY');

    if (!checkinA.isValid() && !checkinB.isValid())
    {
        return 0;
    }

    if (!checkinA.isValid())
    {
        return 1;
    }

    if (!checkinB.isValid())
    {
        return -1;
    }

    return checkinA.isBefore(checkinB) ? -1 : 1;
}

export function sortByDueDate(a, b)
{
    const dateA = moment(a.due_date, 'MM/DD/YYYY');
    const dateB = moment(b.due_date, 'MM/DD/YYYY');

    if (!dateA.isValid() && !dateB.isValid())
    {
        return 0;
    }

    if (!dateA.isValid())
    {
        return 1;
    }

    if (!dateB.isValid())
    {
        return -1;
    }

    return dateA.isBefore(dateB) ? -1 : 1;
}

export function sortReservationsByCheckin(reservations, direction = 'ASC')
{
    const sorted = sortBy(reservations, 'reservationHotels.reservationHotelRooms.checkin');

    return direction === 'ASC' ? sorted : reverse(sorted);
}

export const defaultCursor = {
    count: 0,
    current: 1,
    next: null,
    prev: null,
};
